module.exports = __webpack_public_path__ + "img/14.f4643245.png";